import { FormControl, FormHelperText, Grid, InputLabel, OutlinedInput, TextField } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { DesktopDateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { useStateRef } from 'app/services';
import React, { forwardRef, useEffect, useImperativeHandle, useLayoutEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
const ChecklistInspectionForm = forwardRef((props, ref) => {
    const theme = useTheme();
    const { defaultValues, onSubmit } = props;
    const [firstUpdate, setFirstUpdate, firstUpdateRef] = useStateRef(!!defaultValues);
    const { control, reset, register, setValue, formState, handleSubmit } = useForm({
        defaultValues: {
            name: defaultValues ? defaultValues.name : '',
            from: defaultValues ? moment(defaultValues.from) : '',
        },
    });
    useImperativeHandle(ref, () => ({
        handleFormSubmit: () => {
            handleSubmit((data) => onSubmit(data))();
        },
    }));
    useLayoutEffect(() => {
        if (firstUpdateRef.current !== undefined) {
            setTimeout(() => setFirstUpdate(undefined), theme.transitions.duration.shorter);
        }
    }, [firstUpdateRef.current]);
    useEffect(() => {
        if (defaultValues) {
            reset({
                name: defaultValues.name,
                from: moment(defaultValues.from),
            });
        }
    }, [defaultValues]);
    return (React.createElement("form", null,
        React.createElement(Grid, { container: true, spacing: 2 },
            React.createElement(Grid, { item: true, xs: 6 },
                React.createElement(FormControl, { error: !!formState.errors.name, margin: 'normal', variant: 'outlined', fullWidth: true },
                    React.createElement(InputLabel, { disableAnimation: firstUpdate }, "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043E\u0441\u043C\u043E\u0442\u0440\u0430"),
                    React.createElement(Controller, { name: 'name', control: control, render: ({ field }) => (React.createElement(OutlinedInput, Object.assign({ label: '\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043E\u0441\u043C\u043E\u0442\u0440\u0430', notched: firstUpdate, fullWidth: true, placeholder: '\u0415\u0436\u0435\u0434\u043D\u0435\u0432\u043D\u044B\u0439' }, Object.assign(Object.assign({ variant: 'outlined' }, field), register(field.name, {
                            pattern: /^([А-Яа-я\s]{3,255})$/iu,
                            required: true,
                            minLength: 3,
                        }))))) }),
                    React.createElement(FormHelperText, null, "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0432 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0438 \u043E\u0441\u043C\u043E\u0442\u0440\u0430 \u0442\u043E\u043B\u044C\u043A\u043E \u0431\u0443\u043A\u0432\u044B \u043A\u0438\u0440\u0438\u043B\u043B\u0438\u0446\u044B"))),
            React.createElement(Grid, { item: true, xs: 6 },
                React.createElement(LocalizationProvider, { dateAdapter: AdapterMoment, adapterLocale: moment.locale('ru') },
                    React.createElement(FormControl, { error: !!formState.errors.from, margin: 'normal', variant: 'outlined', fullWidth: true },
                        React.createElement(Controller, { name: 'from', control: control, render: ({ field }) => (React.createElement(DesktopDateTimePicker, { label: '\u0412\u0440\u0435\u043C\u044F \u043F\u0440\u043E\u0432\u0435\u0434\u0435\u043D\u0438\u044F \u043E\u0441\u043C\u043E\u0442\u0440\u0430', views: ['day', 'hours'], minDate: moment().subtract(90, 'days'), maxDate: moment(), inputFormat: 'DD.MM.YYYY HH:mm:ss', value: field.value, onChange: (newValue) => setValue('from', moment(newValue).format('YYYY-MM-DD HH:mm:ss')), renderInput: (props) => (React.createElement(TextField, Object.assign({}, Object.assign(Object.assign(Object.assign({}, props), { notched: firstUpdate, sx: {
                                        svg: {
                                            fontSize: '20px',
                                        },
                                    } }), register(field.name))))) })) }),
                        React.createElement(FormHelperText, null, ".")))))));
});
ChecklistInspectionForm.displayName = 'ChecklistInspectionForm';
export default ChecklistInspectionForm;
